"use client";
import * as React from "react";
const SvgSentimentVeryDissatisfiedFilled = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m10.8-.8a1.2 1.2 0 1 0 0-2.4 1.2 1.2 0 0 0 0 2.4M6.4 6A1.2 1.2 0 1 1 4 6a1.2 1.2 0 0 1 2.4 0m-2.5 6.4a4.4 4.4 0 0 1 8.2 0h-1.34A3.2 3.2 0 0 0 8 10.8a3.2 3.2 0 0 0-2.76 1.6z", clipRule: "evenodd" }));
export {
  SvgSentimentVeryDissatisfiedFilled as default
};
